export default __webpack_public_path__ + "static/thumbnail-8495e76e465026776c1f48538bb43c76.png";